<div class="input-wrapper">
  <div
    class="lib-cm-input"
    [ngClass]="{
      clearable: clearable,
      'border-highlighted': !!vm && highlightIfSet,
      'view-mode': isViewMode,
      'has-error': hasError
    }"
    (click)="openAutoCompletePanel()"
    >
    <!--      row #9 need because, if you click on div.mat-chip-list-wrapper first time,then autocomplete options  will be close at once -->
    <mat-chip-grid #chipList>
      @for (chip of chips; track chip; let i = $index) {
        <mat-chip-row (removed)="remove(i)">
          {{ chip[viewValue] || chip }}
          @if (!isViewMode && !disabled) {
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          }
        </mat-chip-row>
      }
      <input
        [placeholder]="isViewMode || disabled ? '' : placeholder"
        #input
        [formControl]="myControl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)"
        (focus)="openAutoCompletePanel()"
        [disabled]="disabled"
        autocapitalize="none"
        autocomplete="off"
        #trigger="matAutocompleteTrigger"
        />
    </mat-chip-grid>
  </div>

  <mat-autocomplete
    #auto="matAutocomplete"
    [autoActiveFirstOption]="true"
    (optionSelected)="optionSelected($event)"
    [displayWith]="displayProperty.bind(this)"
    >
    @for (option of filteredOptions | async; track option) {
      <mat-option [value]="option">
        <div>{{ option[viewValue] || option }}</div>
      </mat-option>
    }
  </mat-autocomplete>
</div>

